var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Bg1900(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1900,
    height: 648,
    viewBox: "0 0 1900 648",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.223 384.214H456.918V530.772H387.223V640.69H168.255V530.772H-79.1992V407.448L204.049 7.98828H387.223V384.214Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1911.11 384.214H1980.8V530.772H1911.11V640.69H1692.14V530.772H1444.68V407.448L1727.93 7.98828H1911.11V384.214Z",
    fill: "#F8F8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.76 156C1314.75 107.467 1265.22 69.3333 1199.18 41.6C1133.15 13.8667 1050.33 0 950.739 0C900.942 0 855.204 3.73333 813.526 11.2C772.39 18.1333 735.312 28.5333 702.295 42.4C669.277 55.7333 640.319 72 615.42 91.2C591.063 109.867 570.495 131.2 553.715 155.2C537.477 179.2 525.028 205.333 516.367 233.6C508.248 261.867 504.188 291.733 504.188 323.2C504.188 347.2 506.624 370.933 511.496 394.4C516.908 417.867 525.028 440.267 535.853 461.6C547.22 482.933 561.293 503.2 578.072 522.4C595.393 541.067 615.691 558.133 638.966 573.6C662.782 589.067 690.116 602.4 720.969 613.6C751.821 624.267 786.192 632.533 824.081 638.4C862.512 644.8 904.731 648 950.739 648C1015.15 648 1071.71 642.133 1120.43 630.4C1169.68 619.2 1211.9 603.467 1247.09 583.2C1282.27 562.4 1310.96 538.4 1333.15 511.2C1355.34 483.467 1371.58 453.867 1381.86 422.4C1392.15 390.4 1397.29 357.333 1397.29 323.2C1397.29 260.267 1380.78 204.533 1347.76 156Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Bg1900);
export default __webpack_public_path__ + "static/media/404Bg1900.530c0d447cf039dceaf1a4db6a75e8a0.svg";
export { ForwardRef as ReactComponent };